import { CarouselPropsOrder } from '~/interfaces';

export const getOrder = ({ index, pos, numItems }: CarouselPropsOrder) => {
	return index - pos < 0 ? numItems - Math.abs(index - pos) : index - pos;
};

export const NEXT = 'NEXT';
export const PREV = 'PREV';